import React from 'react';
import { CTAButton } from './CTAButton';
import { ClockIcon, ShieldCheckIcon, TrendingUpIcon } from 'lucide-react';
export function WhyThisSkill() {
  return <section className="bg-[#0a1628] py-16 md:py-24 px-4 border-t border-blue-900/30 relative overflow-hidden" data-id="element-270">
      {/* Decorative background */}
      <div className="absolute right-0 top-1/4 w-96 h-96 bg-blue-600/5 rounded-full blur-[100px] pointer-events-none" data-id="element-271"></div>

      <div className="max-w-4xl mx-auto space-y-12 relative z-10" data-id="element-272">
        {/* Merged: Ahorro de tiempo + Proceso Completo */}
        <div className="bg-[#0d1b2a] p-8 md:p-10 rounded-2xl shadow-xl border border-blue-900/30 relative overflow-hidden" data-id="element-273">
          <div className="absolute top-0 right-0 p-6 opacity-10" data-id="element-274">
            <ClockIcon className="w-32 h-32 text-blue-400" data-id="element-275" />
          </div>

          <h2 className="text-2xl md:text-4xl font-black text-white mb-6 uppercase leading-tight relative z-10" data-id="element-276">
            AHORRATE MESES DE PRUEBA Y ERROR CON UN{' '}
            <span className="text-blue-400" data-id="element-277">PROCESO COMPLETO</span>
          </h2>

          <div className="text-lg text-gray-300 space-y-6 leading-relaxed relative z-10" data-id="element-278">
            <p data-id="element-279">
              En vez de obligarte a aprender mezclando videos y tutoriales
              desordenados, acá tenés una ruta pensada para alguien que arranca
              desde cero. No te enseñamos solo a instalar, te enseñamos a
              entender el proceso entero.
            </p>

            <div className="grid md:grid-cols-2 gap-4 mt-6" data-id="element-280">
              <div className="bg-[#0a1628] p-5 rounded-xl border border-blue-900/20" data-id="element-281">
                <p className="font-bold text-white mb-3 flex items-center gap-2" data-id="element-282">
                  <span className="w-2 h-2 rounded-full bg-blue-500" data-id="element-283"></span>
                  Vas a aprender a:
                </p>
                <ul className="space-y-2 text-sm md:text-base" data-id="element-284">
                  <li className="text-gray-400" data-id="element-285">• Elegir y comprar equipos</li>
                  <li className="text-gray-400" data-id="element-286">• Instalar con seguridad</li>
                  <li className="text-gray-400" data-id="element-287">• Configurar acceso remoto</li>
                  <li className="text-gray-400" data-id="element-288">• Resolver fallas comunes</li>
                </ul>
              </div>

              <div className="bg-blue-900/20 p-5 rounded-xl border border-blue-500/20 flex flex-col justify-center" data-id="element-289">
                <p className="font-bold text-blue-300 text-center text-xl" data-id="element-290">
                  Cuando tenés una estructura clara, todo se vuelve más simple y
                  avanzás con confianza.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Imaginá esto */}
        <div className="bg-gradient-to-br from-blue-700 to-blue-900 text-white p-8 md:p-10 rounded-2xl shadow-2xl border border-blue-500/30 relative overflow-hidden" data-id="element-291">
          <div className="absolute -right-10 -bottom-10 opacity-20 transform rotate-12" data-id="element-292">
            <ShieldCheckIcon className="w-48 h-48 text-white" data-id="element-293" />
          </div>

          <h2 className="text-3xl font-black mb-6 uppercase text-yellow-400 relative z-10" data-id="element-294">
            IMAGINÁ ESTO
          </h2>

          <div className="text-lg space-y-4 font-medium relative z-10 max-w-2xl" data-id="element-295">
            <p className="flex items-start gap-3" data-id="element-296">
              <span className="text-blue-300 mt-1" data-id="element-297">→</span>
              En vez de sentirte perdido con términos técnicos, empezás a
              entender cómo funciona todo.
            </p>
            <p className="flex items-start gap-3" data-id="element-298">
              <span className="text-blue-300 mt-1" data-id="element-299">→</span>
              En vez de no saber qué comprar, sabés exactamente qué necesitás.
            </p>
            <p className="flex items-start gap-3" data-id="element-300">
              <span className="text-blue-300 mt-1" data-id="element-301">→</span>
              En vez de pensar "algún día voy a aprender", empezás hoy con una
              guía concreta.
            </p>
            <div className="mt-6 p-4 bg-black/20 rounded-xl border border-white/10 backdrop-blur-sm" data-id="element-302">
              <p className="text-xl font-bold text-yellow-400 text-center" data-id="element-303">
                Empezás a ver la instalación de cámaras como una habilidad real
                que podés desarrollar y monetizar.
              </p>
            </div>
          </div>
        </div>

        {/* Valor de la habilidad + Costo de postergar merged */}
        <div className="grid md:grid-cols-2 gap-6" data-id="element-304">
          <div className="bg-[#0d1b2a] p-8 rounded-2xl border border-blue-900/30 flex flex-col" data-id="element-305">
            <div className="w-12 h-12 bg-blue-900/40 rounded-xl flex items-center justify-center mb-6 border border-blue-500/20" data-id="element-306">
              <TrendingUpIcon className="w-6 h-6 text-blue-400" data-id="element-307" />
            </div>
            <h2 className="text-2xl font-black text-white mb-4 uppercase" data-id="element-308">
              UNA HABILIDAD CON DEMANDA
            </h2>
            <p className="text-gray-300 mb-4" data-id="element-309">
              La seguridad no es un lujo, es una necesidad. Cada vez más casas y
              comercios buscan controlar sus espacios.
            </p>
            <p className="font-bold text-blue-300 mt-auto bg-blue-900/20 p-3 rounded-lg border border-blue-900/40" data-id="element-310">
              Se necesitan personas que sepan instalar correctamente estos
              sistemas.
            </p>
          </div>

          <div className="bg-red-900/10 p-8 rounded-2xl border border-red-900/30 flex flex-col" data-id="element-311">
            <h2 className="text-2xl font-black text-red-400 mb-4 uppercase" data-id="element-312">
              EL COSTO DE POSTERGAR
            </h2>
            <p className="text-gray-300 mb-4" data-id="element-313">
              Seguir aprendiendo por tu cuenta parece más fácil, pero termina
              saliendo caro:
            </p>
            <ul className="space-y-2 text-sm text-gray-400 mb-4 flex-grow" data-id="element-314">
              <li data-id="element-315">• Tiempo perdido en contenido desordenado</li>
              <li data-id="element-316">• Compras innecesarias o mal hechas</li>
              <li data-id="element-317">• Inseguridad para pasar a la práctica</li>
            </ul>
            <p className="font-bold text-white mt-auto" data-id="element-318">
              Con un sistema claro, el aprendizaje cambia. Tenés dirección.
            </p>
          </div>
        </div>

        <div className="text-center pt-8" data-id="element-319">
          <CTAButton className="w-full md:w-auto text-xl py-5 px-12 shadow-[0_0_30px_rgba(234,179,8,0.2)]" data-id="element-320">
            [QUIERO APROVECHAR HOY]
          </CTAButton>
        </div>
      </div>
    </section>;
}